import Image from "next/image";

type LemonMarkProps = {
  /** Rendered width in px. Height follows the art's aspect ratio. */
  size: number;
  className?: string;
  alt?: string;
  preload?: boolean;
};

export default function LemonMark({
  size,
  className,
  alt = "",
  preload = false,
}: LemonMarkProps) {
  return (
    <Image
      sizes={`${size}px`}
      priority={preload}
      draggable={false}
      style={{ width: size, height: "auto" }}
      width={1920}
      height={1754}
      alt={alt}
      src="/logo.svg"
      unoptimized
      className={className}
    />
  );
}
